<template>
  <div>
    <div class="alert bg-dark-Custom w-100 text-center sticky">
      <p class="text-warning ml-2 d-inline">
        پس از انتخاب اقساط مورد نظر بر روی دکمه تایید اقساط کلیک کنید
      </p>
      <button
        v-if="ListTaahodatRiz != null && ListTaahodatRiz != []"
        type="button"
        class="btn btn-success mr-1"
        dir="ltr"
        :disabled="sumMabRiz <= 0 ? true : false"
        data-dismiss="modal"
        @click="SetMablagh"
      >
        <span v-if="sumMabRiz > 0"> تایید اقساط </span>
        <span v-else>لطفا یک یا چند قسط را انتخاب نمایید</span>
      </button>
    </div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="bg-light">
          <tr class="text-center">
            <th scope="col">#</th>
            <th scope="col">تاریخ قسط</th>
            <th scope="col">مبلغ قسط</th>
            <th scope="col">مبلغ جریمه</th>
            <th scope="col">تاریخ سند</th>
            <th scope="col">شماره سند</th>
            <th scope="col">عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(itemRiz, key) in ListTaahodatRiz"
            :key="key"
            class="text-center"
            :class="itemRiz.select == true ? 'bg-success-custom' : ''"
          >
            <th scope="row">{{ key + 1 }}</th>
            <td>{{ itemRiz.tarixGhest }}</td>
            <td>{{ $Comma3ragham(itemRiz.mablaghGhest) }}</td>
            <td>{{ $Comma3ragham(itemRiz.mabJarime) }}</td>
            <td>
              {{
                itemRiz.tarixSanad == null ? "سند ثبت نشده" : itemRiz.tarixSanad
              }}
            </td>
            <td>
              {{
                itemRiz.shomareSanad == null
                  ? "سند ثبت نشده"
                  : itemRiz.shomareSanad
              }}
            </td>
            <td v-if="itemRiz.shomareSanad == null">
              <button
                type="button"
                class="badge font-weight-normal px-2 py-1 mr-1 w-100"
                :class="
                  itemRiz.select == true
                    ? ' btn-outline-orange'
                    : ' btn-outline-success bg-light'
                "
                dir="ltr"
                @click="SelectRiz(itemRiz)"
              >
                <span class="mr-2">{{
                  itemRiz.select == true ? "حذف" : "انتخــاب"
                }}</span>
                <span
                  :class="
                    itemRiz.select == true ? 'fa fa-times' : 'fa fa-check'
                  "
                ></span>
              </button>
            </td>
            <td v-else class="text-center">سند شده</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ListTaahodatRiz: null,
      sumMabRiz: 0,
      sumMabJarime: 0,
    };
  },
  props: ["taahodatId"],
  methods: {
    GetTaahodatRiz(taahodatId) {
      let DataAxios_Taahodatriz = {
        ArryfildValue: "",
        Method: "Post",
        Action: "LoanCardex",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("taahodatId", taahodatId);
      formData.append(
        "shobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId
      );
      DataAxios_Taahodatriz.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Taahodatriz).then((data) => {
        if (typeof(data) == "string") {
          data = JSON.parse(data)
          for (let index = 0; index < data.length; index++) {
          var element = data[index];
          for (var key in element) {
            var temp = JSON.parse(JSON.stringify(key)) 
            var newkey =temp.charAt(0).toLowerCase() + temp.slice(1);
            element[ newkey ] = element[key];
            element[ 'row' ] = index +1
            delete element[key];
          }

          }
          this.ListTaahodatRiz = data

        }
        else if (data.status && data.status=='Ok') {
          this.ListTaahodatRiz = data.result
        }
        else{
         
          var list = [];
            data.forEach((element) => {
            element.select = false;
            list.push(element);
          });
          // this.ListTaahodatRiz=data.result
          this.ListTaahodatRiz = list;
        
        }

      });
    },
    SelectRiz(itemRiz) {
      if (itemRiz.shomareSanad == null || itemRiz.tarixSanad == null) {
        itemRiz.select = !itemRiz.select;
        let ItemMab = itemRiz.mablaghGhest;
        
        let ItemMabJarime = itemRiz.mabJarime;
        let ItemMabBakhshesh = itemRiz.mabBakhshesh==undefined ? 0 : itemRiz.mabBakhshesh;
        if (itemRiz.select) {
          itemRiz['mabBakhshesh']= itemRiz.mabBakhshesh==undefined ? 0 : itemRiz.mabBakhshesh;
          this.CountSelectedTaahodatRizMovaghat += 1;
          this.sumMabRiz = this.sumMabRiz + ItemMab;
          this.sumMabJarime = (this.sumMabJarime + (ItemMabJarime-ItemMabBakhshesh));

        } else {
          if (this.CountSelectedTaahodatRiz > 0) {
            this.CountSelectedTaahodatRizMovaghat -= 1;
          }
          this.sumMabRiz = this.sumMabRiz - ItemMab;
          this.sumMabJarime = (this.sumMabJarime - (ItemMabJarime-ItemMabBakhshesh));
        }
        //  console.log(this.sumMabRiz);
      } else {
        this.$mySweetDefaultTost(
          "عدم انتخاب",
          "قسط انتخابی شما ثبت سند شده ، لطفا قسط دیگیری را انتخاب کنید",
          "warning",
          3000
        );
      }
    },
    SetMablagh() {
      this.SaveTaahodatRiz()
      // console.log(this.sumMabRiz);
      // console.log(this.sumMabJarime);
      // console.log(Math.floor(this.sumMabJarime));
      // console.log(this.sumMabRiz+Math.floor(this.sumMabJarime));
      this.$emit("SumMablagh", this.sumMabRiz+Math.floor(this.sumMabJarime));
      this.$emit("SumMablaghJarime", this.sumMabJarime);
      
    },
    SaveTaahodatRiz(){
      let list=[]
      for (let index = 0; index < this.ListTaahodatRiz.length; index++) {
        if (this.ListTaahodatRiz[index].select== true) {
          list.push(this.ListTaahodatRiz[index]);
        }
      }
      this.$emit("ListTaahodatRiz", list);
    },
    // getCardexFromApiService(Resultcmb){
    //   var data = {
    //     b_DbName: "BnpCashDB",
    //     b_SpName: "b_sp_SelCardex",
    //     prm: [
    //       Resultcmb
    //     ],
    //     IsDataTable: false
    //   };
     
    //   this.$PostDataAPISERVICE({ArryfildValue:data, Token: this.$session.get("TokenNetPa")}).then((data) => {
    //     console.log("!!!!",data);
    //      for (let index = 0; index < data.length; index++) {
    //       var element = data[index];
    //       for (var key in element) {
    //         var temp = JSON.parse(JSON.stringify(key)) 
    //         var newkey =temp.charAt(0).toLowerCase() + temp.slice(1);
    //         element[ newkey ] = element[key];
    //         element[ 'row' ] = index
    //         delete element[key];
    //       }
    //   }
    //      var list = [];
    //       data.forEach((element) => {
    //         element.select = false;
    //         list.push(element);
    //       });
    //       // this.ListTaahodatRiz=data.result
    //       this.ListTaahodatRiz = list;
      
    //   })
    // }
  },
  mounted() {
    this.sumMabJarime=0;
    // this.GetTaahodatRiz(this.taahodatId);
    this.GetTaahodatRiz(this.taahodatId);
  },
};
</script>
<style scoped>
.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  font-size: 20px;
  z-index: 10000;
}
.bg-success-custom {
  background: #d1bd9e !important;
}
</style>
<style>
.modal-body {
  max-height: 500px;
  overflow-y: auto;
}
</style>
